const normalizeString = (value) => String(value || '').trim().toLowerCase();

const formatDateForFilter = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const buildCurrentMonthRange = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  return {
    date_from: formatDateForFilter(new Date(year, month, 1)),
    date_to: formatDateForFilter(new Date(year, month + 1, 0)),
  };
};

export const createDefaultPaymentReceiptsToolbarFilters = () => ({
  ...buildCurrentMonthRange(),
  customer_ids: [],
  payment_form_codes: [],
  payment_account_ids: [],
});

export const normalizePaymentReceiptsToolbarFilters = (filters) => {
  const safeFilters = filters && typeof filters === 'object' ? filters : {};

  return {
    date_from: String(safeFilters.date_from || '').trim(),
    date_to: String(safeFilters.date_to || '').trim(),
    customer_ids: Array.isArray(safeFilters.customer_ids) ? safeFilters.customer_ids : [],
    payment_form_codes: Array.isArray(safeFilters.payment_form_codes) ? safeFilters.payment_form_codes : [],
    payment_account_ids: Array.isArray(safeFilters.payment_account_ids) ? safeFilters.payment_account_ids : [],
  };
};

const matchesDateRange = (row, dateFrom, dateTo) => {
  if (!dateFrom && !dateTo) {
    return true;
  }

  const rowDate = new Date(String(row?.date || ''));
  if (Number.isNaN(rowDate.getTime())) {
    return false;
  }

  const startDate = dateFrom ? new Date(`${dateFrom}T00:00:00`) : null;
  const endDate = dateTo ? new Date(`${dateTo}T23:59:59`) : null;

  if (startDate && rowDate < startDate) {
    return false;
  }

  if (endDate && rowDate > endDate) {
    return false;
  }

  return true;
};

const includesValue = (selectedValues, value) => {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
    return true;
  }

  return selectedValues.map((item) => String(item)).includes(String(value));
};

export const filterPaymentReceiptsRowsByToolbar = (rows, { search, filters }) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const normalizedSearch = normalizeString(search);
  const normalizedFilters = normalizePaymentReceiptsToolbarFilters(filters);

  return safeRows.filter((row) => {
    if (normalizedSearch !== '') {
      const relationLinesText = (Array.isArray(row?.relation_lines) ? row.relation_lines : [])
        .map((line) => {
          const reference = normalizeString(line?.reference);
          const amount = normalizeString(line?.amount);
          return `${reference} ${amount}`.trim();
        })
        .filter(Boolean)
        .join(' ');

      const haystack = [
        row?.folio,
        row?.customer_name,
        row?.relation,
        relationLinesText,
        row?.payment_form,
        row?.payment_form_code,
        row?.payment_account,
        row?.bank_account,
        row?.total,
      ]
        .map((item) => normalizeString(item))
        .join(' ');

      if (!haystack.includes(normalizedSearch)) {
        return false;
      }
    }

    if (!matchesDateRange(row, normalizedFilters.date_from, normalizedFilters.date_to)) {
      return false;
    }

    if (!includesValue(normalizedFilters.customer_ids, row?.customer_id)) {
      return false;
    }

    if (!includesValue(normalizedFilters.payment_form_codes, row?.payment_form_code)) {
      return false;
    }

    if (!includesValue(normalizedFilters.payment_account_ids, row?.payment_account_id)) {
      return false;
    }

    return true;
  });
};
